export const LOCAL_STORAGE_USER_KEY = 'user';
